import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import sonesta from "../assets/img/sonesta.png";
import doomBurst from "../assets/img/doomburst.png";
import LookAi from "../assets/img/lookai.png";
import flickPlix from "../assets/img/flickplix.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import farmer from "../assets/img/smart-farmer.png";
import bank from "../assets/img/bank.png";
import projmanager from "../assets/img/proj-manager.png";
import instrument from "../assets/img/instrument.png";
import blogburst from "../assets/img/blogburst.png";
import muthu from "../assets/img/muthu.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "LOOK AI",
      description: "Research Project",
      imgUrl: LookAi,
      link: "https://look-ai-web-yl66.vercel.app/",
      techStack: ["React JS"],
    },
    {
      title: "Hotel Sonesta",
      description: "Custom Web Design",
      imgUrl: sonesta,
      link: "https://sonesta-frontend-design-eeih.vercel.app/",
      techStack: ["React JS"],
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: bank,
      link: "https://react-fully-responsive-project.vercel.app/",
      techStack: ["React JS"],
    },
    {
      title: "Smart Farmer",
      description: "Research Project",
      imgUrl: farmer,
      link: "https://smart-farmer.vercel.app/",
      techStack: ["React JS"],
    },
  ];

  const apps = [
    {
      title: "Muthugala Group Ledger",
      description:
        "Mobile-responsive business dashboard for inventory, sales, and financial operations built for a real client",
      imgUrl: muthu,
      link: "https://muthugala-group-ledger.vercel.app/",
      techStack: ["React.js", "Node.js", "MongoDB"],
    },
    {
      title: "Flick Plix",
      description: "Movie streaming discovery web app with dynamic UI",
      imgUrl: flickPlix,
      link: "https://github.com/Yasiru-Deshan/Flick-Plix",
      techStack: ["JavaScript", "React.js"],
    },
    {
      title: "DoomBurst",
      description: "Full-stack social media application",
      imgUrl: doomBurst,
      link: "https://drive.google.com/file/d/14wluA7osj1joQdDWOATu5iGHyUTpn0uq/view?usp=drive_link",
      techStack: ["JavaScript", "Node.js", "MongoDB"],
    },
    {
      title: "Project Manager",
      description: "Learning management and evaluation platform",
      imgUrl: projmanager,
      link: "https://github.com/Yasiru-Deshan/File-Saver-Application",
      techStack: ["React.js", "Node.js"],
    },
    {
      title: "Instrumental Shop",
      description: "Product retail management with cart and order processing",
      imgUrl: instrument,
      link: "https://github.com/Yasiru-Deshan/MU-Shop",
      techStack: ["Java", "JSP", "Servlets"],
    },
    {
      title: "Blog Burst",
      description:
        "Featured blog platform with category filtering and content management",
      imgUrl: blogburst,
      link: "https://github.com/Yasiru-Deshan/BlogBurst",
      techStack: ["React.js", "Node.js"],
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p style={{ color: "rgb(212, 237, 228)" }}>
                    Explore some of my diverse projects showcasing a range of
                    skills in web design and development.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                      style={{ cursor: "pointer" }}
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Web Apps</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Web Designs</Nav.Link>
                      </Nav.Item>
                      {/* <Nav.Item>
                        <Nav.Link eventKey="third">Mobile Apps</Nav.Link>
                      </Nav.Item> */}
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {apps.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          {projects.map((app, index) => {
                            return <ProjectCard key={index} {...app} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="third">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane> */}
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="" src={colorSharp2}></img>
    </section>
  );
};
